import { ChangeDetectionStrategy, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DigitalCourse } from '@modules/course/digitalcourse/models';
import { TRANSLATION_SCOPE } from '../../i18n/scope';
import { Multimedia } from '@modules/shared/models/multimedia';
import { ConfigService } from '@modules/core/services/config.service';


@Component({
  selector: 'app-digital-course-preview-card',
  templateUrl: './digital-course-preview-card.component.html',
  styleUrls: ['./digital-course-preview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DigitalCoursePreviewCardComponent implements OnInit, OnChanges {
  @Input() course: DigitalCourse = null;

  translationScope = TRANSLATION_SCOPE;
  baseUrl: string = '/digitalkurs/';
  arrangerLogo: string = '/assets/icons/logo.png';

  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes?.course && changes.course.currentValue && (changes?.course?.currentValue?.arrangerMedia.length > 0)) {
        this.setArrangerLogo(changes.course.currentValue.arrangerMedia);
    }
  }

  getDefaultImage(media: Multimedia[]): string {
    if (media.length) {
      return media.find((media) => media.default == true).url;
    } else {
      return this.defaultBanner();
    }
  }

  defaultBanner(): string {
    const env = this.configService.getCurrent().env;

    switch (env) {
      case 'production':
        return 'https://rssjoliv-prod.imgix.net/harbour/harbour_default_banner.png';
      case 'staging':
        return 'https://rssjoliv-staging.imgix.net/harbour/harbour_default_banner.png';
      default:
        return 'https://rssjoliv-dev.imgix.net/harbour/harbour_default_banner.png';
    }
  }

  private setArrangerLogo(arrangerMedia: Multimedia[]) {
    const {url: arrangerMediaLogoUrl} = arrangerMedia.find((media:Multimedia) => media.default === true);
    this.arrangerLogo = arrangerMediaLogoUrl || '/assets/icons/logo.png';
  }

  public courseIsFree(course: DigitalCourse): boolean {
    return this.priceCalculation(course)[1] === 0;
  }

  public priceCalculation(course: DigitalCourse): [string, number] {
    let price = 0;
    if (course) {
      if (course.price.pricePerGroup !== 0 && course.price.pricePerPerson !== 0) {
        // price = (course.price.pricePerGroup + course.group.min * course.price.pricePerPerson) * duration;
      }
      price = course.price.pricePerPerson;
    }
    if (price === 0) {
      let priceString = '';
      //this.translate.get('FREE_EXPERIENCE').subscribe((res: string) => (priceString = res));
      return [priceString, price];
    } else {
      return [price.toString(), price];
    }
  }

}
